// @flow

import React, { useState } from 'react';

import { Modal } from '@zapier/common-components';
import { useTrackEvent } from '@zapier/toolbox-tracking';

import TrialCloseButton from '../TrialCloseButton';
import routes from './routes';

import { type Size } from '@zapier/design-system-company/src/types';

type Props = {
  /** The current account id (for submitting survey) */
  accountId: number,
  /** The index of the view to show when the modal first opens */
  initialView?: string,
  /** Callback to be executed when the modal is closed */
  onClose: () => void,
  /** Size */
  size: Size,
  /** End date of trial */
  trialEndDate: string,
};

/**
 * Shown to the user when they start a new companies trial.
 */
const TrialWelcomeModal = (props: Props) => {
  const [activeView, setActiveView] = useState(
    props.initialView || 'companyInfo'
  );
  const onRoute = route => setActiveView(route);

  const currentRoute = routes[activeView] || routes.companyInfo;

  useTrackEvent(`company-trial-modal-${activeView}-view`, {
    accountId: props.accountId,
  });

  return (
    <Modal
      closeOnOutsideClick={true}
      maxWidth={600}
      onClose={props.onClose}
      overflowX="visible"
      overflowY="auto"
      padding={0}
      renderCloseButton={() => <TrialCloseButton onClose={props.onClose} />}
    >
      <currentRoute.Component
        accountId={props.accountId}
        onClose={props.onClose}
        onRoute={onRoute}
        size={props.size}
        trialEndDate={props.trialEndDate}
      />
    </Modal>
  );
};

export default TrialWelcomeModal;
